import { isEmpty } from "lodash";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";

const DefaultView = () => {
  const [totalRevisedCost, setTotalRevisedCost] = useState(0);
  const [totalRevisedCeiling, setTotalRevisedCeiling] = useState(0);

  const { scopeFinancialList } = useSelector((state) => ({
    scopeFinancialList: state.projectReducer.scopeFinancialList,
  }));

  useEffect(() => {
    if (isEmpty(scopeFinancialList)) return;

    const approvedComponents = scopeFinancialList.filter(
      (obj) => obj.is_rejected === false,
    );

    const totalApprovedCost = approvedComponents.reduce(
      (acc, obj) => acc + parseFloat(obj.revised_cost_required),
      0,
    );
    const totalApprovedCeiling = approvedComponents.reduce(
      (acc, obj) => acc + parseFloat(obj.revised_ceiling),
      0,
    );

    setTotalRevisedCost(totalApprovedCost);
    setTotalRevisedCeiling(totalApprovedCeiling);
  }, [scopeFinancialList]);

  return (
    <div className='table-responsive'>
      <Table size='sm' className='m-0' style={{ fontSize: 12 }}>
        <thead className='text-uppercase '>
          <tr>
            <th className='text-center'>Bil.</th>
            <th className=''>Skop Projek</th>
            <th className='text-center'>Kos Disemak</th>
            <th className='text-center'>Siling Disemak</th>
          </tr>
        </thead>
        <tbody>
          {scopeFinancialList?.map((obj, idx) => {
            const isRejected = obj.is_rejected;
            return (
              <tr>
                <td className='text-center'>{idx + 1}</td>
                <th className='text-uppercase'>
                  <span
                    className={`${
                      isRejected ? "text-decoration-line-through" : ""
                    }`}
                  >
                    {obj.cost_description}
                  </span>
                  {isRejected && (
                    <span className='ms-1 text-error'>
                      (Skop tidak diperaku)
                    </span>
                  )}
                </th>
                <td className='text-end pe-4'>
                  <span
                    className={`${
                      isRejected ? "text-decoration-line-through" : ""
                    }`}
                  >
                    {numeral(obj?.revised_cost_required).format("0,0.00")}
                  </span>
                </td>
                <td className='text-end pe-4'>
                  <span
                    className={`${
                      isRejected ? "text-decoration-line-through" : ""
                    }`}
                  >
                    {numeral(obj?.revised_ceiling).format("0,0.00")}
                  </span>
                </td>
              </tr>
            );
          })}
          <tr>
            <th colSpan={2} className='text-end text-uppercase'>
              Jumlah diluluskan
            </th>
            <td className='text-end pe-4'>
              {numeral(totalRevisedCost).format("0,0.00")}
            </td>
            <td className='text-end pe-4'>
              {numeral(totalRevisedCeiling).format("0,0.00")}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default DefaultView;
